import { UnitOfMeasurement, UnitOfSpeed } from "../../types/types";

const METRIC_TO_IMPERIAL_SPEED_CONVERT_FACTOR = 0.621371;
const IMPERIAL_TO_METRIC_SPEED_CONVERT_FACTOR = 1.60934;

/**
 * Convert any speed given the original speed & it's unit, plus the target uomPref
 * @param speed original number
 * @param speedUnit corresponding original speed unit type
 * @param uomPref user's preference (target format)
 */
export const convertSpeed = (
    speed: number, 
    speedUnit: UnitOfSpeed, 
    uomPref: UnitOfMeasurement,
): number => {
    if (uomPref === UnitOfMeasurement.BritishImperial) {
        if (speedUnit === UnitOfSpeed.BritishImperial) {
            return speed;
        } else if (speedUnit === UnitOfSpeed.Metric) {
            return Math.round(speed * METRIC_TO_IMPERIAL_SPEED_CONVERT_FACTOR);
        } else {
            throw new Error('Unhandled speedUnit passed to convertSpeed()');
        }
    } else if (uomPref === UnitOfMeasurement.Metric) {
        if (speedUnit === UnitOfSpeed.Metric) {
            return speed;
        } else if (speedUnit === UnitOfSpeed.BritishImperial) {
            return Math.round(speed * IMPERIAL_TO_METRIC_SPEED_CONVERT_FACTOR);
        } else {
            throw new Error('Unhandled speedUnit passed to convertSpeed()');
        }
    } else {
        throw new Error('Unhandled uomPref passed to convertSpeed()');
    }
}